/* One poster renderer for Builder and Cart. Customer values are always escaped. */
(function () {
  'use strict';
  if (window.NLPoster) return;
  var SHEET_W = 500, SHEET_H = 700, INK = '#4A3428', TEXT_Y = 595, TERRA = '#B5523A';
  function topMm(cm) { return Math.max(7.5, (TEXT_Y - cm * 10) / 2); }
  function esc(value) { return String(value).replace(/[&<>"']/g, function (c) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  }); }
  /** Locale-aware formatting: dates and thousands as the shopper's language writes them. */
  function Fmt(locale) {
    this.locale = locale || 'de';
    try {
      this.dateFmt = new Intl.DateTimeFormat(this.locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
      this.numFmt = new Intl.NumberFormat(this.locale, { maximumFractionDigits: 1 });
    } catch (e) {
      this.dateFmt = null; this.numFmt = null;
    }
  }
  Fmt.prototype.date = function (iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!m) return '';
    if (!this.dateFmt) return m[3] + '.' + m[2] + '.' + m[1];
    return this.dateFmt.format(new Date(+m[1], +m[2] - 1, +m[3]));
  };
  Fmt.prototype.weight = function (g) {
    return this.numFmt ? this.numFmt.format(Math.round(g)) : String(Math.round(g));
  };
  Fmt.prototype.length = function (cm) {
    return this.numFmt ? this.numFmt.format(cm) : String(cm).replace('.', ',');
  };

  /** Renders the poster exactly like the print renderer: figure crown-to-heel = length, 3 cm from the top. */
  function PosterSvg(forms, t, fmt) {
    this.forms = forms; this.t = t; this.fmt = fmt;
  }

  /** The Line: the birth length as a bare 1:1 measure, same top rule and text block as the figure. */
  PosterSvg.prototype.lineArt = function (s) {
    var top = topMm(s.length), bot = top + s.length * 10, x = 250;
    var ink = s.line === 'mass' ? TERRA : INK;
    var out = '<line x1="' + x + '" y1="' + top.toFixed(2) + '" x2="' + x + '" y2="' + bot.toFixed(2) + '" stroke="' + ink + '" stroke-width="2"/>';
    if (s.line === 'punkt') {
      out += '<circle cx="' + x + '" cy="' + top.toFixed(2) + '" r="4" fill="' + ink + '"/><circle cx="' + x + '" cy="' + bot.toFixed(2) + '" r="4" fill="' + ink + '"/>';
    } else {
      out += '<line x1="' + (x - 14) + '" y1="' + top.toFixed(2) + '" x2="' + (x + 14) + '" y2="' + top.toFixed(2) + '" stroke="' + ink + '" stroke-width="2"/>' +
             '<line x1="' + (x - 14) + '" y1="' + bot.toFixed(2) + '" x2="' + (x + 14) + '" y2="' + bot.toFixed(2) + '" stroke="' + ink + '" stroke-width="2"/>';
    }
    if (s.line === 'mass') {
      for (var cm = 10; cm < s.length; cm += 10) {
        var y = (top + cm * 10).toFixed(2);
        out += '<line x1="' + (x - 5) + '" y1="' + y + '" x2="' + (x + 5) + '" y2="' + y + '" stroke="' + ink + '" stroke-width="1"/>';
      }
    }
    return out;
  };

  PosterSvg.prototype.figureArt = function (s) {
    var form = this.forms[s.pose];
    var h = s.length * 10, w = h * form.aspect;
    var top = topMm(s.length), x = (SHEET_W - w) / 2;
    var flip = s.side === 'rechts' ? ' transform="translate(' + SHEET_W + ' 0) scale(-1 1)"' : '';
    return '<g' + flip + '><image href="' + form.src + '" x="' + x.toFixed(2) + '" y="' + top.toFixed(2) + '" width="' + w.toFixed(2) + '" height="' + h.toFixed(2) + '" preserveAspectRatio="none" style="mix-blend-mode:multiply"/></g>';
  };

  PosterSvg.prototype.render = function (s) {
    var art = s.style === 'linie' ? this.lineArt(s) : this.figureArt(s);
    var nameY = TEXT_Y;
    var l1 = this.fmt.length(s.length) + ' ' + this.t.cm.toUpperCase() + '   ·   ' + (s.weight ? this.fmt.weight(s.weight) + ' ' + this.t.g.toUpperCase() : '');
    var parts = [this.fmt.date(s.date), s.time, (s.place || '').toUpperCase()].filter(Boolean);
    var sans = 'font-family="NL Jost, sans-serif" font-weight="300" fill="' + INK + '" text-anchor="middle" letter-spacing="0.9"';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + SHEET_W + ' ' + SHEET_H + '" preserveAspectRatio="none" role="img" aria-label="' + esc(this.t.svg_label) + '">' +
      '<rect width="' + SHEET_W + '" height="' + SHEET_H + '" fill="' + s.paperHex + '"/>' +
      art +
      '<text x="250" y="' + (nameY + 20).toFixed(1) + '" font-family="NL Cormorant, serif" font-weight="500" font-size="24" fill="' + INK + '" text-anchor="middle">' + esc(s.name || '') + '</text>' +
      '<text x="250" y="' + (nameY + 39).toFixed(1) + '" font-size="6.2" ' + sans + '>' + esc(l1.replace(/\s+·\s+$/, '')) + '</text>' +
      '<text x="250" y="' + (nameY + 50.5).toFixed(1) + '" font-size="6.2" ' + sans + '>' + esc(parts.join('   ·   ')) + '</text>' +
      '<text x="250" y="684" font-size="4.5" ' + sans + '>' + esc(this.t.scale) + '</text>' +
      '</svg>';
  };


  function fromProperties(p) {
    if (!p || p._preview_version !== '1' || typeof p._name !== 'string' || !p._name.trim() || p._name.length > 200) return null;
    var cm = Number(p._length_cm), style = p._style;
    if (!Number.isFinite(cm) || cm < 35 || cm > 57.5 || ['aquarell','linie'].indexOf(style) < 0) return null;
    if (style === 'aquarell' && ['ruhe','wiege','traum'].indexOf(p._pose) < 0) return null;
    if (['links','rechts'].indexOf(p._side) < 0 || ['none','white','black','canvas'].indexOf(p._frame) < 0) return null;
    if (style === 'linie' && ['punkt','strich','mass'].indexOf(p._line) < 0) return null;
    var papers = {papier:'#F6F0E7',leinen:'#ECE4D6',sand:'#E4D6C4',salbei:'#DEE2D4',nebel:'#E0E4E6'};
    if (!Object.prototype.hasOwnProperty.call(papers, p._paper) || !/^\d{4}-\d{2}-\d{2}$/.test(p._date || '')) return null;
    return {style:style, line:p._line, pose:p._pose, side:p._side, frame:p._frame,
      paper:p._paper, paperHex:papers[p._paper], name:p._name, length:cm,
      weight: /^\d{1,5}$/.test(p._weight_g || '') ? Number(p._weight_g) : 0,
      date:p._date, time:/^\d{2}:\d{2}$/.test(p._time || '') ? p._time : '',
      place: typeof p._place === 'string' ? p._place.slice(0,200) : ''};
  }
  window.NLPoster = Object.freeze({Fmt:Fmt, PosterSvg:PosterSvg, fromProperties:fromProperties});
})();
